import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export const useAuthErrorHandler = () => {
  const navigate = useNavigate();
  const { toast } = useToast();

  useEffect(() => {
    // Listen for auth state changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      // Handle session expiration
      if (event === 'SIGNED_OUT') {
        toast({
          title: "Signed Out",
          description: "You have been signed out. Please sign in again to continue.",
          variant: "destructive",
        });
        navigate('/auth');
      }
      
      // Handle token refresh failures (session becomes null)
      if (event === 'TOKEN_REFRESHED' && !session) {
        toast({
          title: "Session Expired",
          description: "Your session has expired. Please sign in again.",
          variant: "destructive",
        });
        navigate('/auth');
      }
    });

    return () => subscription.unsubscribe();
  }, [navigate, toast]);

  // Function to handle edge function errors
  const handleEdgeFunctionError = (error: any) => {
    if (error?.message?.includes('Unauthorized') || 
        error?.message?.includes('session') ||
        error?.message?.includes('Auth') ||
        error?.status === 401 ||
        error?.status === 403) {
      toast({
        title: "Authentication Error",
        description: "Your session has expired. Please sign in again.",
        variant: "destructive",
      });
      
      // Sign out and redirect
      supabase.auth.signOut().then(() => {
        navigate('/auth');
      });
      
      return true; // Error was handled
    }
    return false; // Error was not an auth error
  };

  return { handleEdgeFunctionError };
};
